import { Action } from '@ngrx/store';

export class FinanceActions implements Action {

    public static getFinancePosition: string = '[FINANCE] getAvaibleToInvest';
    public static getFinancePositionError: string = '[FINANCE] getAvaibleToInvestError';
    public static getFinancePositionSuccess: string = '[FINANCE] getAvaibleToInvestSuccess';
    public static getFinancePositionStopped: string = '[FINANCE] getAvaibleToInvestStopped';

    public static getNoteIncomeDate: string = '[FINANCE] getNoteIncomeDate';
    public static getNoteIncomeDateError: string = '[FINANCE] getNoteIncomeDateError';
    public static getNoteIncomeDateSuccess: string = '[FINANCE] getNoteIncomeDateSuccess';

    public static getBrokageNoteIncome: string = '[FINANCE] getBrokageNoteIncome';
    public static getBrokageNoteIncomeError: string = '[FINANCE] getBrokageNoteIncomeError';
    public static getBrokageNoteIncomeSuccess: string = '[FINANCE] getBrokageNoteIncomeSuccess';

    public static getConsolidatePosition: string = '[FINANCE] getConsolidatePosition';
    public static getConsolidatePositionError: string = '[FINANCE] getConsolidatePositionError';
    public static getConsolidatePositionSuccess: string = '[FINANCE] getConsolidatePositionSuccess';

    public static getExtractDates: string = '[FINANCE] getExtractDates';
    public static getExtractDatesError: string = '[FINANCE] getExtractDatesError';
    public static getExtractDatesSuccess: string = '[FINANCE] getExtractDatesSuccess';

    public static getExtractPDF: string = '[FINANCE] getExtractPDF';
    public static getExtractPDFError: string = '[FINANCE] getExtractPDFError';
    public static getExtractPDFSuccess: string = '[FINANCE] getExtractPDFSuccess';

    public static getRealtimeConsolidatedPosition: string = '[FINANCE] getRealtimeConsolidatedPosition';
    public static getRealtimeConsolidatedPositionError: string = '[FINANCE] getRealtimeConsolidatedPositionError';
    public static getRealtimeConsolidatedPositionSuccess: string = '[FINANCE] getRealtimeConsolidatedPositionSuccess';

    public static getRealtimeFinancePosition: string = '[FINANCE] getRealtimeFinancePosition';
    public static getRealtimeFinancePositionError: string = '[FINANCE] getRealtimeFinancePositionError';
    public static getRealtimeFinancePositionSuccess: string = '[FINANCE] getRealtimeFinancePositionSuccess';

    public static getSheduleTransfer: string = '[FINANCE] getSheduleTransfer';
    public static getSheduleTransferError: string = '[FINANCE] getSheduleTransferError';
    public static getSheduleTransferSuccess: string = '[FINANCE] getSheduleTransferSuccess';

    public static getIncomeTaxPDF: string = '[FINANCE] getIncomeTaxPDF';
    public static getIncomeTaxPDFError: string = '[FINANCE] getIncomeTaxPDFError';
    public static getIncomeTaxPDFSuccess: string = '[FINANCE] getIncomeTaxPDFSuccess';

    public static getSecondaryReports: string = '[FINANCE] getSecondaryReports';
    public static getSecondaryReportsError: string = '[FINANCE] getSecondaryReportsError';
    public static getSecondaryReportsSuccess: string = '[FINANCE] getSecondaryReportsSuccess';

    public static getReport: string = '[FINANCE] getReport';
    public static getReportError: string = '[FINANCE] getReportError';
    public static getReportSuccess: string = '[FINANCE] getReportSuccess';

    public static getReportByType: string = '[FINANCE] getReportByType';
    public static getReportByTypeError: string = '[FINANCE] getReportByTypeError';
    public static getReportByTypeSuccess: string = '[FINANCE] getReportByTypeSuccess';

    public static getWithdrawHistory: string = '[Withdraw] get_withdraw_history';
    public static getWithdrawHistoryError: string = '[Withdraw] get_withdraw_history_error';
    public static getWithdrawHistorySuccess: string = '[Withdraw] get_withdraw_history_success';    

    public static getTransferExecutionDate: string = '[Withdraw] get_transfer_execute_date';
    public static getTransferExecutionDateError: string = '[Withdraw] get_transfer_execute_date_error';
    public static getTransferExecutionDateSuccess: string = '[Withdraw] get_transfer_execute_date_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
